/**
 *  @class
 *  @function MediaWithTabs
 */
if (!customElements.get('media-with-tabs')) {
  class MediaWithTabs extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.buttons = Array.from(this.querySelectorAll('.media-with-tabs--button'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      this.slider = this.querySelector('slide-show');
      this.buttons.forEach((button, i) => {
        button.addEventListener('click', () => {
          this.buttonClick(button, i);
        });
        button.addEventListener('keydown', (e) => {
          this.handleKeydown(e, i);
        });
      });
    }
    buttonClick(button, i) {
      let flkty = Flickity.data(this.slider);
      
      // Update buttons
      this.buttons.forEach((btn, index) => {
        const isSelected = index === i;
        btn.setAttribute('aria-selected', isSelected);
        btn.setAttribute('tabindex', isSelected ? '0' : '-1');
        btn.parentElement.classList.toggle('active', isSelected);
      });
      
      // Update panels
      this.panels.forEach((panel, index) => {
        if (index === i) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });

      flkty.select(i);
    }
    handleKeydown(e, currentIndex) {
      let newIndex = currentIndex;
      
      switch(e.key) {
        case 'ArrowLeft':
        case 'ArrowUp':
          e.preventDefault();
          newIndex = currentIndex > 0 ? currentIndex - 1 : this.buttons.length - 1;
          break;
        case 'ArrowRight':
        case 'ArrowDown':
          e.preventDefault();
          newIndex = currentIndex < this.buttons.length - 1 ? currentIndex + 1 : 0;
          break;
        case 'Home':
          e.preventDefault();
          newIndex = 0;
          break;
        case 'End':
          e.preventDefault();
          newIndex = this.buttons.length - 1;
          break;
        default:
          return;
      }
      
      this.buttons[newIndex].focus();
      this.buttonClick(this.buttons[newIndex], newIndex);
    }
  }
  customElements.define('media-with-tabs', MediaWithTabs);
}